/**
 * @file kernel.js
 * @description Central service locator for the application.
 * Manages all singleton services and provides a simple
 * interface for dependency injection.
 */

// Import all singleton services
import ContentManager from './managers/contentManager.js';
import ThemeManager from './managers/themeManager.js';
import StateManager from './managers/stateManager.js';
import EventBus from './utils/eventBus.js';
import AiSearchConnector from './managers/aiSearchConnector.js';

export class Kernel {
    constructor() {
        this.services = new Map();
        
        // Register all services
        this.register('content', ContentManager);
        this.register('theme', ThemeManager);
        this.register('state', StateManager);
        this.register('eventBus', EventBus);
        this.register('aiSearch', AiSearchConnector);
    }

    /**
     * Registers a new service.
     * @param {string} name - The "key" for the service.
     * @param {object} serviceInstance - The singleton instance.
     */
    register(name, serviceInstance) {
        if (this.services.has(name)) {
            console.warn(`[Kernel] Service "${name}" is already registered.`);
            return;
        }
        this.services.set(name, serviceInstance);
    }

    /**
     * Retrieves a registered service.
     * @param {string} name - The "key" of the service to get.
     * @returns {object} The service instance.
     */
    get(name) {
        const service = this.services.get(name);
        if (!service) {
            throw new Error(`[Kernel] Service not found: "${name}".`);
        }
        return service;
    }
}